'use strict';

var publicKey = require('./public-key.js');

const AccountId = publicKey.PublicKey;

exports.AccountId = AccountId;
//# sourceMappingURL=account-id.js.map
